import React, { useRef } from 'react';
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TableWithHeadingAndGlobalSearch from '../../components/Table/TableWithHeadingAndGlobalSearch';
import _ from 'lodash';
import { useCallback } from 'react';
import { useEffect } from 'react';
import { Calendar, Clock, Edit2, PhoneCall } from 'react-feather';
import { useState } from 'react';
import {
    fetchPurchaseOrder,
    fetchPurchaseOrders,
    getPurchaseOrder,
    updatePurchaseOrder,
    updatePurchaseOrderQuantity,
} from '../../app/reducers/PurchaseOrder/purchaseOrderSlice';
import EditPurchaseModal from './EditPurchaseModal';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import moment from 'moment';
import { useFormik } from 'formik';
import FormikSelectGroup from '../../components/formik/FormikSelectGroup';
import { generateOptions } from '../../utils/Utils';
import EditMenu from '../../components/DropdownEditMenu/DropdownEditMenu';
import axios from 'axios';
import { toast } from 'react-toastify';
import { customIDs } from '../../utils/customIds';
import AttachmentModal from './AttachmentModal';
import ContactModal from './ContactModal';
import EditDateModal from '../SplitQuarterData/EditDateModal';
import PrimaryBadge from '../../components/infrastructure/Badges/PrimaryBadge';
import { openReminderPopUp } from '../../app/reducers/ReminderPopUp/reminderPopUpSlice';
import QueryString from 'qs';
import { authAxiosInstance } from '../../utils/axiosConfig';
import { ClipLoader, ClockLoader } from 'react-spinners';
import AdvanceSearchModal from './AdvanceSearchModal';
import SplitScheduleModal from './SplitScheduleModal';
import ToggleButton from '../../components/ToggleButton/ToggleButton';
import PhoneIconBox from '../../components/infrastructure/PhoneIconBox';
import { fetchContacts } from '../../app/reducers/Contacts/contactsSlice';
import PhoneIconBoxWithBuyer from '../../components/infrastructure/PhoneIconBoxWithBuyer';

const ViewPurchaseOrder = () => {
    const [page, setPage] = useState(1);
    const [viewPurchaseModal, setPurchaseModal] = useState(false);
    const [loadingReminder, setLoadingReminder] = useState(false);
    const [everyDayFollowUp, setEveryDayFollowUp] = useState(false);
    const [errorsPO, setErrorsPO] = useState(false);

    const [viewAttachmentModal, setAttachmentModal] = useState(false);
    const [attachmentData, setAttachmentData] = useState(false);
    const [editData, setEditData] = useState({});
    const [requestData, setRequestData] = useState({});
    const [spitModal, setSplitModal] = useState(false);
    const [contactModalOpen, setContactModalOpen] = useState(false);
    const [contactDetails, setContactDetails] = useState({});
    const [editDateModalOpen, setEditDateModalOpen] = useState(false);
    const [editPoId, setEditPoId] = useState(null);
    const [showSplitScheduleModal, setShowSplitScheduleModal] = useState(false);

    const searchRef = useRef(null);

    const organization_id = 637857442;
    const dispatch = useDispatch();

    const poStatusStyle = (status) => {
        if (status === 'billed') {
            return 'bg-gray-200 border-b-2 border-white';
        } else if (status == 'cancelled') {
            return 'bg-red-200 border-b-2 border-white';
        }
    };

    const { purchaseOrder, loading } = useSelector(getPurchaseOrder); // created on 16-11-22

    const purchaseOrdersData = useMemo(
        () =>
            purchaseOrder?.purchaseorders
                ? purchaseOrder.purchaseorders.map((d) => ({
                      ...d,
                      className: poStatusStyle(d.status),
                  }))
                : [],
        [purchaseOrder]
    );
    console.log('purchaseOrder data', purchaseOrdersData);
    const purchaseOrderPageContext = useMemo(
        () => (purchaseOrder?.page_context ? purchaseOrder.page_context : []),
        [purchaseOrder]
    );

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            search: 'vendor',
        },
    });

    // const convertBill = async (data) => {
    //     setButtonId(data.purchaseorder_id)
    //     dispatch(convertToBill({ id: data.purchaseorder_id}))
    //     dispatch(fetchPurchaseOrders({ page: page,status:'open' }))
    // }
    // const { purchaseOrderLoading } = useSelector(getPurchaseOrder);
    useEffect(() => {
        const fetchPayload = {
            page: page,
            status: 'open',
        };
        if (everyDayFollowUp) {
            fetchPayload['custom_field_466597000011301196'] =
                'EVERYDAY FOLLOWUP';
        }

        if (errorsPO) {
            fetchPayload['custom_field_466597000032007149'] = 'Error';
        }
        dispatch(fetchPurchaseOrders(fetchPayload));
    }, [page, everyDayFollowUp, errorsPO]);

    useEffect(()=>{
        searchRef.current?.focus();
    },[])

    const waModified = async (row) => {
        const action = await dispatch(
            fetchPurchaseOrder({ id: row.purchaseorder_id })
        );
        if (action.payload?.purchaseorder) {
            const vendorCheck = await axios.get(
                `https://app2.com.bot/webhook/641a5e12a52b8e34db70b32c?contact_type=vendor&po_id=${row.purchaseorder_id}&org_id=${organization_id}&contact_id=${row.vendor_id}&delivery_date=${row.delivery_date}`
            );
            if (vendorCheck.data?.accepted) {
                toast.success('Vendor True');
            } else {
                toast.error('Not accepted try again');
            }
            const customerCheck = await axios.get(
                `https://app2.com.bot/webhook/641a5e12a52b8e34db70b32c?contact_type=customer&po_id=${row.purchaseorder_id}&org_id=${organization_id}&contact_id=${action.payload.purchaseorder.delivery_customer_id}&delivery_date=${row.delivery_date}`
            );
            if (customerCheck.data?.accepted) {
                toast.success('Customer True');
            } else {
                toast.error('Not accepted try again');
            }
        } else {
            toast.error('Something Went Wrong.Please try again');
        }
    };

    const deliveryConfirmation = async (row) => {
        const action = await dispatch(
            fetchPurchaseOrder({ id: row.purchaseorder_id })
        );
        if (action.payload?.purchaseorder) {
            const deliveryCheck = await axios.get(
                `https://app2.com.bot/webhook/6475aeddb5c9a37453be5805?vendor_id=${row.vendor_id}&customer_id=${action.payload.purchaseorder.delivery_customer_id}&po_id=${row.purchaseorder_id}`
            );
            if (deliveryCheck.data?.accepted) {
                toast.success('Delivery Confiramtion :True');
            } else {
                toast.error('Not accepted try again');
            }
        } else {
            toast.error('Something Went Wrong.Please try again');
        }
    };

    const sendChallan = async (row) => {
        const action = await dispatch(
            fetchPurchaseOrder({ id: row.purchaseorder_id })
        );
        if (action.payload?.purchaseorder) {
            const sendChallanCheck = await axios.get(
                `https://app2.com.bot/webhook/64390a78985aa6cc38fefe9f?vendor_id=${row.vendor_id}&customer_id=${action.payload.purchaseorder.delivery_customer_id}&po_id=${row.purchaseorder_id}`
            );
            if (sendChallanCheck.data?.accepted) {
                toast.success('Delivery Confiramtion :True');
            } else {
                toast.error('Not accepted try again');
            }
        } else {
            toast.error('Something Went Wrong.Please try again');
        }
    };
    const sendAddressToVendor = async (row) => {
        const action = await dispatch(
            fetchPurchaseOrder({ id: row.purchaseorder_id })
        );
        if (action.payload?.purchaseorder) {
            const sendAddressCheck = await axios.get(
                `https://app2.com.bot/webhook/641a5d6ca52b8e34db70ae9f?vendor_id=${row.vendor_id}&customer_id=${action.payload.purchaseorder.delivery_customer_id}&po_id=${row.purchaseorder_id}`
            );
            if (sendAddressCheck.data?.accepted) {
                toast.success('Send Address Vendor Success');
            } else {
                toast.error('Not accepted try again');
            }
        } else {
            toast.error('Something Went Wrong.Please try again');
        }
    };
    

    const cols = [
        {
            Header: 'Action',
            Cell: ({ row, data }) => {
                return (
                    <div
                        className="flex items-center gap-2"
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                    >
                        <Edit2
                            color="blue"
                            className="cursor-pointer"
                            onClick={() => {
                                console.log(row);
                                setPurchaseModal(true);
                                setEditData({
                                    id: row.original.purchaseorder_id,
                                    page: page,
                                });
                            }}
                        />
                        {loadingReminder == row.original.purchaseorder_id ? (
                            <ClockLoader size={25} speedMultiplier={2} />
                        ) : (
                            <button
                                onClick={async (e) => {
                                    e.stopPropagation();
                                    setLoadingReminder(
                                        row.original.purchaseorder_id
                                    );
                                    let popUpData = { ...row.original };
                                    console.log(row.original, 'check data');
                                    //Vendor Mobile No.
                                    const data = {
                                        id: row.original?.vendor_id,
                                    };
                                    const string = QueryString.stringify(data);
                                    const contacts =
                                        await authAxiosInstance.get(
                                            `purchase-orders/contacts/${data.id}?${string}`
                                        );
                                    if (contacts?.data?.data) {
                                        popUpData['vendorMobileNo'] =
                                            contacts?.data?.data?.contact?.contact_persons?.[0]?.mobile;
                                    }
                                    //Customer Mobile No.
                                    const customerData = {
                                        search: row.original?.cf_buyer_name,
                                    };
                                    const customerString =
                                        QueryString.stringify(customerData);
                                    const customerContacts =
                                        await authAxiosInstance.get(
                                            `purchase-orders/contacts?${customerString}`
                                        );
                                    console.log(customerContacts, 'new');
                                    if (customerContacts?.data?.data) {
                                        popUpData['customerMobileNo'] =
                                            customerContacts?.data?.data?.contacts?.[0]?.mobile;
                                    }
                                    dispatch(
                                        openReminderPopUp({
                                            isOpen: true,
                                            data: {
                                                ...popUpData,
                                                type: 'vendor',
                                                reminderType: 'PO_reminder',
                                                path: 'purchaseorders',
                                                path_id:
                                                    popUpData.purchaseorder_id,
                                            },
                                        })
                                    );
                                    setLoadingReminder('');
                                }}
                            >
                                <Clock
                                    size={25}
                                    color={
                                        row.original['cf_po_reminder'] ==
                                            'YES' ||
                                        row.original['cf_complaint_reminder'] ==
                                            'YES'
                                            ? '#ffff1a'
                                            : 'black'
                                    }
                                />
                            </button>
                        )}
                        <EditMenu align="left" className="relative inline-flex">
                            <li>
                                <span
                                    onClick={() => waModified(row.original)}
                                    className="font-medium text-sm text-slate-600 hover:text-slate-800 flex py-1 px-3"
                                    style={{ cursor: 'pointer' }}
                                >
                                    WA Team Modified PO
                                </span>
                            </li>
                            <hr></hr>
                            <li>
                                <span
                                    onClick={() =>
                                        deliveryConfirmation(row.original)
                                    }
                                    className="font-medium text-sm text-slate-600 hover:text-slate-800 flex py-1 px-3"
                                    style={{ cursor: 'pointer' }}
                                >
                                    Delivery Confirmation
                                </span>
                            </li>
                            <hr></hr>
                            <li>
                                <span
                                    onClick={() => sendChallan(row.original)}
                                    className="font-medium text-sm text-slate-600 hover:text-slate-800 flex py-1 px-3"
                                    style={{ cursor: 'pointer' }}
                                >
                                    Send Challan
                                </span>
                            </li>
                            <hr></hr>
                            <li>
                                <span
                                    onClick={() =>
                                        sendAddressToVendor(row.original)
                                    }
                                    className="font-medium text-sm text-slate-600 hover:text-slate-800 flex py-1 px-3"
                                    style={{ cursor: 'pointer' }}
                                >
                                    Send Address To Vendor
                                </span>
                            </li>
                        </EditMenu>
                        {/* {
                         btnId == row.original.purchaseorder_id && purchaseOrderLoading ? <ClipLoader /> :   
                        <PrimaryButton onClick={(e) => {
                            e.stopPropagation()
                            convertBill(row.original)
                        }} >Convert to Bill</PrimaryButton>
                        } */}
                    </div>
                );
            },
        },

        {
            Header: 'PURCHASE ORDER#',
            Cell: ({ row, data }) => {
                return (
                    <>
                        <div
                            className={
                                row?.original?.has_attachment
                                    ? 'underline text-blue-500 cursor-pointer'
                                    : 'cursor-pointer'
                            }
                            onClick={(e) => {
                                e.stopPropagation();
                                setAttachmentData({
                                    id: row.original.purchaseorder_id,
                                    page: page,
                                });
                                setAttachmentModal(true);
                            }}
                        >
                            {row.original.purchaseorder_number}
                            <span className="text-[0.5rem]">
                                {row?.original?.cf_last_c_uplod_dt}
                            </span>
                        </div>
                        <div className="mt-1">
                            <ToggleButton
                                toggled={
                                    row?.original?.cf_tag_3 &&
                                    row?.original?.cf_tag_3 ===
                                        'EVERYDAY FOLLOWUP'
                                }
                                onClick={(e) => {
                                    e.stopPropagation();
                                    console.log('row', row?.original);
                                    if (
                                        row?.original?.cf_tag_3 &&
                                        row?.original?.cf_tag_3 ===
                                            'EVERYDAY FOLLOWUP'
                                    ) {
                                        const updatePayload = {
                                            customfield_id:
                                                customIDs.purchase_custom_tag_3,
                                            value: '',
                                        };
                                        dispatch(
                                            updatePurchaseOrderQuantity({
                                                id: row?.original
                                                    ?.purchaseorder_id,
                                                custom_fields: [updatePayload],
                                            })
                                        );
                                        // .then((res)=>{
                                        //     console.log('res',res)
                                        //     if(res?.payload){
                                        //         dispatch(fetchPurchaseOrders({ page: page, status: 'open' }));
                                        //     }
                                        // })
                                    } else {
                                        const updatePayload = {
                                            customfield_id:
                                                customIDs.purchase_custom_tag_3,
                                            value: 'EVERYDAY FOLLOWUP',
                                        };
                                        dispatch(
                                            updatePurchaseOrderQuantity({
                                                id: row?.original
                                                    ?.purchaseorder_id,
                                                custom_fields: [updatePayload],
                                            })
                                        );
                                        // .then((res)=>{
                                        //     console.log('res',res)
                                        //     if(res?.payload){
                                        //         dispatch(fetchPurchaseOrders({ page: page, status: 'open' }));
                                        //     }
                                        // })
                                    }
                                }}
                                // onChange={}
                            />
                        </div>
                    </>
                );
            },
            style: {
                width: '12%',
            },
        },
        {
            Header: 'QTY TAKA',
            accessor: 'cf_qty_taka',
            style: {
                width: '8%',
            },
        },
        {
            Header: 'QUALITY NAME',
            accessor: 'cf_quality_name',
        },
        {
            Header: 'VENDOR NAME',
            Cell: ({ data, row }) => {
                // console.log('row', row?.original);
                return (
                    <div className=" gap-4 flex ">
                        <PhoneIconBox
                            child={<span>{row?.original?.vendor_name}</span>}
                            green={true}
                            blue={true}
                            dot={true}
                            obj={{ contact_id: row?.original?.vendor_id }}
                        />

                        {/* <PhoneCall
                            onClick={(e) => {
                                e.stopPropagation();
                                setContactModalOpen(true);
                                setContactDetails({
                                    contact_type: 'vendor',
                                    name: row.original.vendor_name,
                                });
                            }}
                            color="green"
                            size={18}
                        /> */}
                    </div>
                );
            },
        },
        {
            Header: 'BUYER NAME',
            accessor :'cf_buyer_name' ,
            Cell: ({ data, row }) => {
                return (
                    <div className=" gap-4 flex flex-col">
                        <div className="flex gap-4">
                            <PhoneIconBoxWithBuyer
                                child={
                                    <span>{row?.original?.cf_buyer_name}</span>
                                }
                                obj={{
                                    contact_type: 'customer',
                                    name: row?.original?.cf_buyer_name,
                                }}
                                green={true}
                                blue={true}
                                dot={true}
                            />
                            {/* <PhoneCall
                                onClick={async (e) => {
                                    e.stopPropagation();

                                    const resp = await dispatch(
                                        fetchContacts({
                                            search: contactDetails.name,
                                            contact_type:
                                                contactDetails.contact_type,
                                        })
                                    );
                                    console.log(
                                        'resp',
                                        resp?.payload?.contacts[0]
                                    );
                                    const customerData =
                                        resp?.payload?.contacts[0];
                                    // setContactModalOpen(true);
                                    // setContactDetails({
                                    //     contact_type: 'customer',
                                    //     name: row.original.cf_buyer_name,
                                    // });
                                }}
                                color="blue"
                                size={18}
                            /> */}
                        </div>
                        {row?.original?.['cf_po_note'] && (
                            <div className="flex">
                                <PrimaryBadge>
                                    {
                                        row?.original?.['cf_po_note']?.split(
                                            '-'
                                        )[0]
                                    }
                                </PrimaryBadge>
                                <span className="text-[0.5rem]">
                                    {
                                        row?.original?.['cf_po_note']?.split(
                                            '-'
                                        )[1]
                                    }
                                </span>
                            </div>
                        )}
                    </div>
                );
            },
        },
        {
            Header: 'DATE',
            Cell: ({ row }) => {
                return (
                    <div className="flex flex-col">
                        <span
                            className="underline text-indigo-500 cursor-pointer"
                            onClick={(e) => {
                                e.stopPropagation();
                                setEditDateModalOpen(true);
                                setEditPoId(row.original.purchaseorder_id);
                            }}
                        >
                            Issue Date{' '}
                            {moment(row.original.date).format('DD/MM/YYYY')}
                        </span>
                        <span className="flex gap-2 items-center">
                            Delivery Date{' '}
                            {moment(row.original.delivery_date).format(
                                'DD/MM/YYYY'
                            )}
                            <Calendar
                                color={
                                    row?.original?.cf_split_scheduled?.toLowerCase() ===
                                    'yes'
                                        ? 'red'
                                        : 'black'
                                }
                                className="cursor-pointer"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setShowSplitScheduleModal(true);
                                    setRequestData({
                                        id: row.original.purchaseorder_id,
                                        page: page,
                                    });
                                }}
                                size={13}
                            />
                        </span>
                    </div>
                );
            },
            style: {
                width: '20%',
            },
        },
        {
            Header: 'RATE',
            accessor: 'cf_rate',
        },
        {
            Header: 'AMOUNT',
            accessor: 'total',
        },
    ];

    const handleNext = (e) => {
        e.preventDefault();
        setPage(page + 1);
    };

    const debouncedSearch = useCallback(
        _.debounce((search) => {
            let data = {};

            if (formik.values.search == 'vendor') {
                data['vendor_name_contains'] = search;
            } else {
                data[
                    `custom_field_${customIDs.purchase_custom_buyerName}_contains`
                ] = search;
            }
            console.log(everyDayFollowUp);
            if (everyDayFollowUp) {
                data['custom_field_466597000011301196'] = 'EVERYDAY FOLLOWUP';
            }
            if (errorsPO) {
                data['custom_field_466597000032007149'] = 'Error';
            }
            dispatch(
                fetchPurchaseOrders({
                    ...data,
                    page: 1,
                    status: 'open',
                })
            );
        }, 300),
        [JSON.stringify(formik.values), everyDayFollowUp, errorsPO]
    );

    const [showAdvanceSearch, setShowAdvanceSearch] = useState(false);
    // const advanceSearchFormik = useFormik({
    //     enableReinitialize: true,
    //     initialValues: {
    //         vendor: '',
    //         customer: '',
    //         quality: [],
    //         rate: '',
    //         qty_taka: '',
    //         date_range: '',
    //     },
    //     onSubmit: (values) => {},
    // });
    const [advanceSearchData, setAdvanceSearchData] = useState({
        reset: true,
        data: {},
        hasMore: false,
    });

    return (
        <div className="p-4">
            <AdvanceSearchModal
                // formik={advanceSearchFormik}
                setAdvanceSearchData={setAdvanceSearchData}
                title="Advance Search"
                isOpen={showAdvanceSearch}
                setIsOpen={setShowAdvanceSearch}
            />
            <SplitScheduleModal
                setShowSplitScheduleModal={setShowSplitScheduleModal}
                showSplitScheduleModal={showSplitScheduleModal}
                requestData={requestData}
            />
            <EditPurchaseModal
                title={'Edit Purchase Order'}
                setPurchaseModal={setPurchaseModal}
                viewPurchaseModal={viewPurchaseModal}
                data={editData}
            />
            <AttachmentModal
                viewAttachmentModal={viewAttachmentModal}
                setAttachmentModal={setAttachmentModal}
                data={attachmentData}
            />
            <EditDateModal
                editDateModalOpen={editDateModalOpen}
                setEditDateModalOpen={setEditDateModalOpen}
                editPoId={editPoId}
                setEditPoId={setEditPoId}
                type={'Purchase'}
            />
            <ContactModal
                setContactModalOpen={setContactModalOpen}
                contactModalOpen={contactModalOpen}
                contactDetails={contactDetails}
            />
            {/* <PrimaryButton
                className="mb-2"
                onClick={(e) => {
                    e.stopPropagation();
                    dispatch(fetchPurchaseOrders());
                }}
            >
                Fetch All
            </PrimaryButton> */}
            <div className="mb-3 flex gap-2 ">
                <FormikSelectGroup
                    className={''}
                    formik={formik}
                    label="Search Type"
                    name={`search`}
                    onChange={(selectedOption) => {
                        dispatch(
                            fetchPurchaseOrders({
                                page: page,
                                status: 'open',
                            })
                        );
                        formik.setFieldValue('search', selectedOption.value);
                    }}
                    options={generateOptions({
                        array: [
                            { label: 'Vendor', value: 'vendor' },
                            { label: 'Customer', value: 'customer' },
                        ],
                        labelField: 'label',
                        valueField: 'value',
                    })}
                    required
                />
                <div className="w-[20%] mt-auto">
                    <PrimaryButton
                        onClick={(e) => {
                            e.stopPropagation();
                            setShowAdvanceSearch(true);
                        }}
                        className={'w-full'}
                    >
                        Advance Search
                    </PrimaryButton>
                </div>
            </div>
            {advanceSearchData.hasMore && (
                <span className="text-red-500 my-3">
                    Warning: Found 200 or more purchase orders.
                </span>
            )}
            {!advanceSearchData.reset &&
                Object.values(advanceSearchData.data).map(
                    (purchaseOrders, i) => {
                        let countQtyTaka = purchaseOrders.reduce((acc, ele) => {
                            acc += Number(ele.cf_qty_taka);
                            return acc;
                        }, 0);

                        let modifiedPurchaseOrder = purchaseOrders.map((d) => ({
                            ...d,
                            className: poStatusStyle(d.status),
                        }));

                        return (
                            <div className="py-4" key={i}>
                                <TableWithHeadingAndGlobalSearch
                                    heading={`${purchaseOrders[0]?.cf_quality_name} || (${countQtyTaka})`}
                                    placeholder={`Search for ${
                                        formik.values.search == 'vendor'
                                            ? 'vendor Name'
                                            : 'customer Name'
                                    }`}
                                    data={modifiedPurchaseOrder}
                                    loading={loading}
                                    columns={cols}
                                    searchFunction={(search) => {
                                        debouncedSearch(search);
                                    }}
                                />
                            </div>
                        );
                    }
                )}
            {advanceSearchData.reset && (
                <>
                    <TableWithHeadingAndGlobalSearch
                        focusRef={searchRef}
                        heading={
                            <div className="flex flex-row items-center gap-4">
                                <span>Purchase Orders</span>
                                {/* <button
                                    className="border px-1 py-[0.5px] rounded text-sm bg-gray-100"
                                    onClick={async (e) => {
                                        e.stopPropagation();
                                        const resp =
                                            await authAxiosInstance.get(
                                                `zoho/order/split`
                                            );
                                        console.log('resp', resp);
                                    }}
                                >
                                    Splitting
                                </button> */}
                                <div className="mt-1" id='purchaseOrderToggle'>
                                    <ToggleButton
                                        toggled={everyDayFollowUp}
                                        onClick={() =>
                                            setEveryDayFollowUp(
                                                !everyDayFollowUp
                                            )
                                        }
                                    />
                                </div>
                                <div className="mt-1">
                                    <ToggleButton
                                        className="primary-toggle"
                                        toggled={errorsPO}
                                        onClick={() => setErrorsPO(!errorsPO)}
                                    />
                                </div>
                            </div>
                        }
                        placeholder={`Search for ${
                            formik.values.search == 'vendor'
                                ? 'vendor Name'
                                : 'customer Name'
                        }`}
                        data={purchaseOrdersData}
                        loading={loading}
                        columns={cols}
                        searchFunction={(search) => {
                            debouncedSearch(search);
                        }}
                    />
                    {!loading && (
                        <div className="mt-4 flex gap-3 justify-end">
                            {page > 1 && (
                                <PrimaryButton
                                    onClick={(e) => setPage(page - 1)}
                                >
                                    Previous
                                </PrimaryButton>
                            )}
                            {purchaseOrderPageContext.has_more_page && (
                                <PrimaryButton onClick={(e) => handleNext(e)}>
                                    Next
                                </PrimaryButton>
                            )}
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default ViewPurchaseOrder;
